import type { RouterStatsResponse } from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

/**
 * Typed wrapper around `ops-api /v1/ops/admin/router-stats`.
 *
 * ops-api proxies to gateway-worker's `/internal/router-stats` which
 * aggregates `usage_logs` per `(date, upstream_id)` bucket. The only
 * client-controlled parameter is `days` (gateway caps it at 90; we rely
 * on the handler's clamp rather than re-validating here).
 *
 * Semantics reminder (matches `internal-router-stats.ts` doc):
 *   - `p95LatencyMs` is currently approximated as AVG in gateway — the
 *     Dashboard labels the column accordingly.
 *   - Historical rows for soft-deleted upstreams still show up with
 *     `upstreamName` snapshot at query time; hard-deleted upstreams
 *     expose an empty name which the UI renders as a "deleted" tag.
 */

const BASE_PATH = '/v1/ops/admin/router-stats';

export async function getRouterStats(
  days: number,
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<RouterStatsResponse> {
  const qs = `?days=${encodeURIComponent(days.toString())}`;
  return opsApiRequest<RouterStatsResponse>(`${BASE_PATH}${qs}`, { signal }, fetchImpl);
}
